import PageLayout from '../../layouts/PageLayout';
import EmployeeDashboard from './EmployeeDashBoard';
import AdminDashboard from './AdminDashbaord';
import useCurrentUser from '../../hooks/useCurrentUser';
import { Button, HStack } from '@chakra-ui/react';
import { useState } from 'react';
import LeaveUpload from '../LeaveManagement/LeaveUpload';
import LeaveDownload from '../LeaveManagement/LeaveDownload';
import DashboardCardSkeleton from '../../components/Skeletons/DashboardCardSkeleton';
export const ActionButton = ({ onClick, children }: any) => (
  <Button
    onClick={onClick}
    borderRadius="6px"
    bgGradient="linear(to-r, #6535EB, #9F3198)"
    color="white"
    height={{ base: '26px', md: '34px' }}
    px={{ base: 3, md: 5 }}
    fontSize={{ base: '10px', md: '12px' }}
    fontWeight="500"
    whiteSpace="nowrap"
    transition="all 0.2s ease"
    _hover={{
      transform: 'translateY(-1px)',
      bgGradient: 'linear(to-r, #5a2fe0, #8a2a85)',
    }}
    _active={{
      transform: 'scale(0.98)',
    }}
  >
    {children}
  </Button>
);

function MainDashbaord() {
  const user = useCurrentUser();
  const [openUpload, setOpenUpload] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);

  if (!user) {
    return (
      <PageLayout pageTitle="Dashboard">
        <DashboardCardSkeleton />
        <DashboardCardSkeleton />
        <DashboardCardSkeleton />
        <DashboardCardSkeleton />
      </PageLayout>
    );
  }

  const isAdminOrHR = user.role === 'Admin' || user.role === 'HR';

  return (
    <PageLayout
      pageTitle="Dashboard"
      action2={
        isAdminOrHR ? (
          <HStack spacing={3} align="center" flexWrap="nowrap">
            <ActionButton onClick={() => setOpenUpload(true)}>
              Upload Leave
            </ActionButton>

            <ActionButton onClick={() => setOpenDownload(true)}>
              Download Leave
            </ActionButton>
          </HStack>
        ) : null
      }
    >
      <div className="w-full mt-4">
        {isAdminOrHR ? <AdminDashboard /> : <EmployeeDashboard />}
      </div>

      <LeaveUpload isOpen={openUpload} setIsOpen={setOpenUpload} />
      <LeaveDownload isOpen={openDownload} setIsOpen={setOpenDownload} />
    </PageLayout>
  );
}

export default MainDashbaord;
